
/**
 * Schreibregel fuer jeden Prompt, dessen Antwort im Plan oder beim Nutzer
 * landet. Nennt die Striche absichtlich als Zeichen, damit die KI sie erkennt.
 */
// schreibregel: erlaubt (die Regel nennt die verbotenen Striche als Zeichen)
export const KI_SCHREIBREGEL ='Schreibe ohne Gedankenstriche (– oder —); nutze Komma, Doppelpunkt oder einen neuen Satz. Schreibe Umlaute (ä, ö, ü, ß), keine Umschrift.';

export const AI_PROMPTS = {
  DOKUMENT_ANALYSE: `Du bist ein Experte für Baustellensicherheit und SiGe-Koordination.
Analysiere das hochgeladene Dokument und extrahiere strukturierte Daten für einen SiGe-Plan (Sicherheits- und Gesundheitsschutzplan).

Antworte IMMER im folgenden JSON-Format:
{
  "dokumentTyp": "bauzeitenplan" | "beteiligtenliste" | "leistungsverzeichnis" | "sonstig",
  "arbeitsschritte": [
    {
      "bezeichnung": "string",
      "gewerk": "string",
      "zeitraumVon": "YYYY-MM-DD" | null,
      "zeitraumBis": "YYYY-MM-DD" | null,
      "konfidenz": 0.0
    }
  ],
  "beteiligte": [
    {
      "firma": "string",
      "ansprechpartner": "string",
      "gewerk": "string",
      "kontakt": "string"
    }
  ],
  "hinweise": ["string"]
}

Regeln:
• Extrahiere NUR baurelevante Informationen
• Setze "konfidenz" zwischen 0 und 1 (wie sicher bist du, dass dies ein relevanter Arbeitsschritt ist)
• Sortiere Arbeitsschritte chronologisch wenn möglich
• "hinweise" enthält wichtige Beobachtungen für den SiGeKo (z.B. gleichzeitige Arbeiten)
• ${KI_SCHREIBREGEL}`,

  // schreibregel: erlaubt (Enum-Schlüssel "laerm" der Kategorie, die KI muss ihn wörtlich liefern)
  GEFAEHRDUNGS_VORSCHLAG: `Du bist ein zertifizierter SiGe-Koordinator (SiGeKo) nach RAB 30.
Für den Arbeitsschritt "{bezeichnung}" (Gewerk: {gewerk}) auf einer Baustelle, schlage relevante Gefährdungen und Schutzmaßnahmen vor.

Bereits erfasste Gefährdungen (nicht wiederholen):
{vorhandeneGefaehrdungen}

Antworte im JSON-Format:
{
  "gefaehrdungen": [
    {
      "bezeichnung": "string",
      "kategorie": "absturz | mechanisch | elektrisch | gefahrstoffe | laerm | brand | verkehr | witterung | psychisch | biologisch | sonstig",
      "schutzmassnahmen": [
        {
          "beschreibung": "string",
          "verantwortlich": "string",
          "regelwerkReferenz": "string"
        }
      ],
      "prioritaet": "hoch | mittel | niedrig"
    }
  ]
}

Regeln:
• "regelwerkReferenz" nennt nur ein real existierendes, derzeit gültiges deutsches Regelwerk, das sicher passt, OHNE Paragraphen-, Absatz- oder Anhangsangabe; im Zweifel leerer String. Erfinde nie ein Regelwerk.
• Priorisiere nach Eintrittswahrscheinlichkeit × Schadensschwere
• Nenne konkrete, umsetzbare Maßnahmen
• Maximal 4 Gefährdungen pro Arbeitsschritt mit je 1 bis 2 Schutzmaßnahmen, zusammen höchstens 5 Schutzmaßnahmen, nur die wichtigsten
• "beschreibung" ist ein Stichwort, kein Satz: höchstens 60 Zeichen, ohne Punkt am Ende (z. B. "Seitenschutz 3-teilig ab 2 m Absturzhöhe")
• "regelwerkReferenz" nur als Kurzbezeichnung ohne Titel (z. B. "DGUV V 38", "DGUV R 101-038", "TRBS 2121", "ASR A2.1")
• Die Maßnahmen stehen später auf einem Aushang-Plan; jede Zeile mehr macht ihn länger und schwerer lesbar
• ${KI_SCHREIBREGEL}`,

  // Rückfall des Altplan-Imports (altplanLesen.ts), wenn das PDF keine
  // lesbare Textebene hat (Scan) oder nicht aus der Excel-Vorlage stammt.
  // Die KI schreibt AB — sie bewertet nichts und ergänzt nichts.
  ALTPLAN_ABSCHRIFT: `Du erhältst einen alten Sicherheits- und Gesundheitsschutzplan (SiGe-Plan) als PDF.
Schreibe ihn WORTGETREU ab. Ergänze nichts, korrigiere nichts, erfinde nichts. Fehlt etwas oder ist es unleserlich, lass das Feld leer.

Aufbau des Plans: eine Matrix mit Abschnittsüberschriften (z. B. "Baustelleneinrichtung", "gemeinsam genutzte Einrichtung: VERKEHRSWEGE") und Zeilen mit den Spalten
"Arbeiten bzw. Leistungen" | "Schutzeinrichtung bzw. Schutzmaßnahme" | "Arbeitsschutzvorschrift" | "Hinweise" | Zeitbalken | "Koordinierungsbedarf" | Zuständigkeit "Erstellung" | "Kontrolle" | "Instandhaltung".
Daneben Notrufplan, Legende und Plankopf (Bauherr, Baumaßnahme, Plan-Nr., Datum, bearbeitet/geprüft/überarbeitet, SiGeKo).

Antworte NUR mit diesem JSON:
{
  "plankopf": {
    "bauherr_name": "", "bauherr_adresse": "", "baumassnahme_name": "", "baumassnahme_adresse": "",
    "plan_nr": "", "plan_datum": "YYYY-MM-DD", "plan_inhalt": "",
    "sigeko_name": "", "sigeko_mobil": "",
    "bearbeitet_name": "", "bearbeitet_datum": "YYYY-MM-DD", "geprueft_name": "", "geprueft_datum": "YYYY-MM-DD", "ueberarbeitet_datum": "YYYY-MM-DD"
  },
  "abschnitte": [
    { "titel": "Überschrift wie im Plan",
      "schritte": [
        { "bezeichnung": "Text der Spalte Arbeiten",
          "schutzmassnahmen": ["je Zeile der Zelle ein Eintrag"],
          "vorschriften": ["je Zeile der Zelle ein Eintrag"],
          "hinweise": ["Codes wie A 024"],
          "von": "YYYY-MM-DD", "bis": "YYYY-MM-DD",
          "koordinierungsbedarf": "", "erstellung": "", "kontrolle": "", "instandhaltung": "" } ] }
  ],
  "notrufplan": {
    "krankenhaus": { "name": "", "adresse": "", "telefon": "" },
    "durchgangsarzt": { "name": "", "adresse": "", "telefon": "" },
    "augenarzt": { "name": "", "adresse": "", "telefon": "" },
    "apotheke": { "name": "", "adresse": "", "telefon": "" },
    "ersthelfer": [{ "name": "", "firma": "" }]
  },
  "legende": [{ "kuerzel": "", "bedeutung": "" }]
}

Regeln:
• Reihenfolge von Abschnitten und Zeilen wie im Plan.
• "von"/"bis": Beginn und Ende des Zeitbalkens der Zeile. Die Balken tragen Tag und Monat ("30. Okt"); das Jahr ergibt sich aus der Jahresleiste über der Zeitachse. Ist ein Datum nicht sicher ablesbar: null.
• Ein am Zeilenende mit Bindestrich getrenntes Wort wieder zusammensetzen.
• Daten immer als YYYY-MM-DD, leere Angaben als "" bzw. null.`
};
